export enum MitekMode {
  MANUAL_CAPTURE = 'MANUAL_CAPTURE',
  AUTO_CAPTURE = 'AUTO_CAPTURE',
}
